import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

const opts = {

  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        primary: '#376374', // Bleu pour poissonnerie (défaut)
        secondary: '#8AC3D5',
        danger: '#EF5350',
        boucherie: '#9d0419', // Rouge pour boucherie
        poissonnerie: '#376374', // Bleu pour poissonnerie
      },
      options: {
        themeVariations: ['primary', 'secondary', 'danger', 'boucherie', 'poissonnerie'],
      },
    },
  },
}
Vue.use(Vuetify)

export default new Vuetify(opts)
